// Étape g : fichiers déposés dans l'ERP (validé par Nils le 16/10). Commun à l'ERP (contrôle avant
// envoi) et au serveur (contrôle qui fait foi, avec la signature du contenu : server/src/fichiers.js).
export const TAILLE_MAX_FICHIER = 25 * 1024 * 1024;
export const EXTENSIONS_FICHIERS = ["pdf", "jpg", "jpeg", "png", "heic", "heif", "dwg", "dxf", "xlsx", "xls", "docx", "doc"];
export const TYPES_FICHIERS_LISIBLES = "PDF, images (JPG, PNG, HEIC), DWG, DXF, Excel, Word";
export const extensionFichier = (nom) => ((/\.([A-Za-z0-9]{1,5})$/.exec(String(nom || "")) || [])[1] || "").toLowerCase();
